module.exports = __webpack_public_path__ + "static/img/89-1.6d339c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/89-1.jpg
// module id = zZvA
// module chunks = 0